exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.el-card[data-v-31235f22] {\r\n  padding: 20px;\n}\n.float-right[data-v-31235f22] {\r\n  float: right;\n}\r\n", ""]);

